import { useAudienceIdentity } from '../context/AudienceIdentityContext';

const teamBgClasses: Record<string, string> = {
  BLUE: 'bg-team-blue text-white',
  RED: 'bg-team-red text-white',
  GREEN: 'bg-team-green text-white',
  YELLOW: 'bg-team-yellow text-white',
};

function NicknameBar() {
  const identity = useAudienceIdentity();

  // Non mostrare in modalità spectator
  if (identity.isSpectator) return null;

  const nickname = identity.nickname;
  if (!nickname) return null;

  const teamClass = identity.teamColor ? teamBgClasses[identity.teamColor.toUpperCase()] : null;

  return (
    <div className={`fixed top-0 left-0 right-0 backdrop-blur-sm border-b-2 px-4 py-2 z-50 ${teamClass || 'bg-parchment-200/95 border-parchment-300'}`}>
      <p className={`text-base text-center truncate font-heading font-bold tracking-wide ${teamClass ? 'text-white/90' : 'text-ink-light'}`}>{nickname}</p>
    </div>
  );
}

export default NicknameBar;
